import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { useNavigate, useParams } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Spinner from "../Header/Spinner/Spinner";
const ProjectDetails = () => {
  const [spinner, setSpinner] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();
  const [project, setProject] = useState({});
  useEffect(() => {
    fetch(`https://thawing-earth-30870.herokuapp.com/projects/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setProject(data);
        setSpinner(false);
      });
  }, [id]);
  const imgs = project.img;
  const responsive = project.responsive;
  if (spinner) {
    return <Spinner />;
  }
  return (
    <div className="border-2 m-2 p-2 rounded">
      <div className="all-btn flex flex-col md:flex-row  justify-center items-center">
        <div className="back-btn mb-2 md:mb-0">
          <button
            onClick={() => navigate("/")}
            className="btn btn-primary my-4 flex "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Go Back Home
          </button>
        </div>
        <div className="liveSite ml-2 mb-2 md:mb-0">
          <a
            href={project.liveSite}
            target="_blank"
            className="btn btn-primary  "
          >
            {" "}
            Live Site
          </a>
        </div>
        <div className="liveSite ml-2 mb-2 md:mb-0">
          <a
            href={project.clientCode}
            target="_blank"
            className="btn btn-primary  "
          >
            {" "}
            {project.serverCode ? "Client Code" : "Project Code "}
          </a>
        </div>
        {project.serverCode && (
          <div className="liveSite ml-2 mb-2 md:mb-0">
            <a
              href={project.serverCode}
              target="_blank"
              className="btn btn-primary  "
            >
              {" "}
              Server Code
            </a>
          </div>
        )}
      </div>
      <Carousel>
        {imgs?.map((image) => (
          <div>
            <img src={image} alt="project-img" />
          </div>
        ))}
      </Carousel>

      <div className="details my-12 flex flex-col justify-center items-center ">
        <h2 className="my-6  text-2xl font-bold">{project.name}</h2>
        <p className="text-xl ">{project.description}</p>
      </div>
      <h1 className="text-3xl font-semibold text-primary my-12 text-center ">
        Responsive View
      </h1>
      <div className="responsive grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 my-12">
        {responsive?.map((res) => (
          <div className="large my-4">
            <img src={res} alt="responsive-img" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectDetails;
